export const MIGRATION_REQUIRED_GROUPS = ["user"];

export function isEmailUsername(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

export function requiresUsernameMigration(user) {
  if (!user?.user_name || !user?.user_group) return false;
  if (!MIGRATION_REQUIRED_GROUPS.includes(user.user_group)) return false;
  return !isEmailUsername(user.user_name);
}

export const MIGRATE_USERNAME_ROUTE = "/migrate-username";
